document.addEventListener('DOMContentLoaded', function () {

  // Call this at the beginning of your code
  addLoadingStyles();

  // mobile nav
  function isMobile() {
    return window.matchMedia("(max-width: 990px)").matches;
  }

  if (isMobile()) {
    //console.log("📱 Mobile detected!");
  } else {
    // const youtubeSection = document.getElementById('adjeii-youtube-to-shopify');
    // const marginHeight = document.querySelector('.header').offsetHeight;
    // youtubeSection.style.marginTop = `${marginHeight + 10}px`
  }

  // Utility function to fetch with multiple proxy fallbacks
  async function fetchWithFallbacks(url) {
    try {
        const proxyUrl = `https://brotherz-youtube-proxy.vercel.app/fetch-youtube?url=${encodeURIComponent(url)}`;
        const response = await fetch(proxyUrl);
        if (!response.ok) throw new Error("Proxy failed");
        return await response.json();
    } catch (error) {
        console.error("❌ Proxy Error:", error);
        return null;
    }
}


  function extractYtInitialData(htmlContent) {
    const match = htmlContent.match(/var ytInitialData = (.+?);<\/script>/s);
    if (match) {
      try {
        return JSON.parse(match[1]); // Return parsed JSON
      } catch (e) {
        console.error("❌ Error parsing extracted ytInitialData:", e);
      }
    }
    return null;
  }

  // Storage keys
  const STORAGE_KEYS = {
    CHANNEL_DATA: 'adjeii_yt_channel_data_',
    VIDEOS_DATA: 'adjeii_yt_videos_data_'
  };

  // Save channel data to localStorage
  function saveChannelData(channelId, data) {
    try {
      const storageKey = `${STORAGE_KEYS.CHANNEL_DATA}${channelId}`;
      const dataWithMeta = {
        ...data,
        timestamp: Date.now(),
        version: '1.0' // For future compatibility
      };
      localStorage.setItem(storageKey, JSON.stringify(dataWithMeta));
      return true;
    } catch (error) {
      console.error('Error saving channel data to storage:', error);
      return false;
    }
  }

  // Load channel data from localStorage
  function loadChannelData(channelId) {
    try {
      const storageKey = `${STORAGE_KEYS.CHANNEL_DATA}${channelId}`;
      const data = localStorage.getItem(storageKey);

      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error loading channel data from storage:', error);
      return null;
    }
  }

  // Save videos data to localStorage
  function saveVideosData(channelId, data) {
    try {
      const storageKey = `${STORAGE_KEYS.VIDEOS_DATA}${channelId}`;
      const dataWithMeta = {
        videos: data,
        latestVideoId: data.length > 0 ? data[0].id : null,
        timestamp: Date.now(),
        version: '1.0'
      };
      localStorage.setItem(storageKey, JSON.stringify(dataWithMeta));
      return true;
    } catch (error) {
      console.error('Error saving videos data to storage:', error);
      return false;
    }
  }

  // Load videos data from localStorage
  function loadVideosData(channelId) {
    try {
      const storageKey = `${STORAGE_KEYS.VIDEOS_DATA}${channelId}`;
      const data = localStorage.getItem(storageKey);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error loading videos data from storage:', error);
      return null;
    }
  }

  // Check if stored data is still valid (not too old)
  function isDataValid(data, maxAgeMs = 24 * 60 * 60 * 1000) { // Default: 24 hours
    if (!data || !data.timestamp) {
      return false;
    }

    const now = Date.now();
    const age = now - data.timestamp;

    return age < maxAgeMs;
  }

  // Clear all stored YouTube data
  function clearAllYouTubeData() {
    try {
      Object.values(STORAGE_KEYS).forEach(keyPrefix => {
        // Find all keys that start with this prefix
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && key.startsWith(keyPrefix)) {
            localStorage.removeItem(key);
          }
        }
      });
      return true;
    } catch (error) {
      console.error('Error clearing YouTube data from storage:', error);
      return false;
    }
  }

  // Update the checkForChannelUpdates function
  async function checkForChannelUpdates(channelId, storedData) {
    try {
      if (!channelId) {
        return false;
      }

      // Use the fallback fetch function
      const channelUrl = `https://www.youtube.com/channel/${channelId}`;
      const htmlContent = await fetchWithFallbacks(channelUrl);

      if (!htmlContent) {
        console.warn('Could not fetch channel data for update check');
        return false; // Can't determine if update needed, use stored data
      }

      // Extract ytInitialData
      const initialDataMatch = htmlContent.match(/var ytInitialData = (.+?);<\/script>/s);
      if (!initialDataMatch) {
        console.warn('Could not find ytInitialData for update check');
        return false;
      }

      // Parse the JSON data
      let ytData;
      try {
        ytData = JSON.parse(initialDataMatch[1]);
      } catch (e) {
        console.error('Error parsing YouTube data for update check:', e);
        return false;
      }

      // Extract subscriber count using the exact path
      let currentSubCount = '';
      try {
        currentSubCount = ytData.header.pageHeaderRenderer.content.pageHeaderViewModel.metadata.contentMetadataViewModel.metadataRows[1].metadataParts[0].text.content;
      } catch (e) {
        console.warn('Could not extract subscriber count for update check:', e);
      }
      // Extract latest video ID
      // Update the code in checkForChannelUpdates and similar functions
      let currentLatestVideoId = '';
      try {
        if (ytData.contents?.twoColumnBrowseResultsRenderer?.tabs) {
          const videosTab = ytData.contents.twoColumnBrowseResultsRenderer.tabs.find(tab =>
            tab.tabRenderer?.title === 'Videos'
          );

          // Add more checks to prevent undefined errors
          if (videosTab &&
            videosTab.tabRenderer &&
            videosTab.tabRenderer.content &&
            videosTab.tabRenderer.content.richGridRenderer &&
            videosTab.tabRenderer.content.richGridRenderer.contents &&
            videosTab.tabRenderer.content.richGridRenderer.contents.length > 0 &&
            videosTab.tabRenderer.content.richGridRenderer.contents[0].richItemRenderer &&
            videosTab.tabRenderer.content.richGridRenderer.contents[0].richItemRenderer.content &&
            videosTab.tabRenderer.content.richGridRenderer.contents[0].richItemRenderer.content.videoRenderer) {

            currentLatestVideoId = videosTab.tabRenderer.content.richGridRenderer.contents[0].richItemRenderer.content.videoRenderer.videoId;

          }
        }
      } catch (e) {
        console.warn('Could not extract latest video ID for update check:', e);
      }


      // If we don't have stored data, we definitely need an update
      if (!storedData || !storedData.subscriberCount) {
        return true;
      }

      // Compare with stored data
      const needsUpdate =
        currentSubCount !== storedData.subscriberCount ||
        (currentLatestVideoId && storedData.latestVideoId !== currentLatestVideoId);

      console.log('Update check:', needsUpdate ? 'Update needed' : 'No update needed');

      return needsUpdate;

    } catch (error) {
      console.error('Error checking for updates:', error);
      return false; // On error, use stored data
    }
  }

  // Update the checkForVideosUpdates function
  async function checkForChannelUpdates(channelId, storedData) {
    try {
      if (!channelId) {
        return false;
      }

      // Fetch channel data
      const channelUrl = `https://www.youtube.com/channel/${channelId}`;
      const ytData = await fetchWithFallbacks(channelUrl);

      if (!ytData) {
        console.warn('Could not fetch channel data for update check');
        return false;
      }

      // Extract subscriber count
      let currentSubCount = '';
      try {
        currentSubCount = ytData.header?.pageHeaderRenderer?.content?.pageHeaderViewModel?.metadata?.contentMetadataViewModel?.metadataRows?.[1]?.metadataParts?.[0]?.text?.content || '';
      } catch (e) {
        console.warn('Could not extract subscriber count for update check:', e);
      }

      // Extract latest video ID
      let currentLatestVideoId = '';
      try {
        const videosTab = ytData.contents?.twoColumnBrowseResultsRenderer?.tabs?.find(tab =>
          tab.tabRenderer?.title === 'Videos'
        );
        if (videosTab?.tabRenderer?.content?.richGridRenderer?.contents?.[0]?.richItemRenderer?.content?.videoRenderer) {
          currentLatestVideoId = videosTab.tabRenderer.content.richGridRenderer.contents[0].richItemRenderer.content.videoRenderer.videoId;
        }
      } catch (e) {
        console.warn('Could not extract latest video ID for update check:', e);
      }

      // If there's no stored data, update is needed
      if (!storedData || !storedData.subscriberCount) {
        return true;
      }

      // Compare new data with stored data
      const needsUpdate =
        currentSubCount !== storedData.subscriberCount ||
        (currentLatestVideoId && storedData.latestVideoId !== currentLatestVideoId);

      // console.log('Update check:', needsUpdate ? 'Update needed' : 'No update needed');
      return needsUpdate;

    } catch (error) {
      console.error('Error checking for updates:', error);
      return false; // Use stored data if error occurs
    }
  }

  // Main class for YouTube to Shopify integration
  class AdjeiYouTubeToShopify {
    constructor(container) {
      // Store the main container element
      this.container = container;

      // Get configuration from data attributes
      this.channelId = container.dataset.channelId;
      this.videosPerPage = parseInt(container.dataset.videosPerPage) || 8;
      this.layout = container.dataset.layout || 'grid';
      this.disableSuggestions = container.dataset.disableSuggestions === 'true';
      this.onlyChannelSuggestions = container.dataset.onlyChannelSuggestions === 'true';

      // State variables
      this.currentPage = 1;
      this.videos = [];
      this.channelInfo = null;

      // DOM elements
      this.videoContainer = container.querySelector('.video-container');
      this.paginationControls = container.querySelector('.pagination-controls');
      this.prevButton = container.querySelector('.prev-page');
      this.nextButton = container.querySelector('.next-page');
      this.currentPageIndicator = container.querySelector('.current-page');
      this.modal = container.querySelector('.video-modal');
      this.modalContent = container.querySelector('.modal-content');
      this.videoPlayer = container.querySelector('.video-player');
      this.closeModal = container.querySelector('.close-modal');

      // Channel info elements
      this.channelTitle = container.querySelector('.channel-title');
      this.channelAvatar = container.querySelector('.channel-avatar-img');
      this.channelBanner = container.querySelector('.channel-banner-img');
      this.subscriberCount = container.querySelector('.subscriber-count');
      this.channelDescription = container.querySelector('.channel-description');
      // Initialize the component
      this.init();
    }

    async init() {
      try {
        this.showLoading();
        // Check if we have stored data first
        const storedChannelData = loadChannelData(this.channelId);
        const storedVideosData = loadVideosData(this.channelId);

        // Use stored data if available
        if (storedChannelData && isDataValid(storedChannelData)) {
          //console.log('Using stored channel data');
          this.channelInfo = storedChannelData;
          this.updateChannelInfo();

          // Check for updates in the background
          this.checkForChannelUpdatesInBackground(storedChannelData);
        } else {
          // No stored data or it's too old, load from source
          await this.loadChannelInfo();
        }

        // Same for videos
        if (storedVideosData && isDataValid(storedVideosData)) {
          //console.log('Using stored videos data');
          this.videos = storedVideosData.videos || [];

          this.renderVideos();
          this.updatePagination();

          this.checkForVideosUpdatesInBackground(storedVideosData);
        } else {
          // No stored data or it's too old, load from source
          await this.loadVideos();
        }

        // Set up event listeners
        this.setupEventListeners();

      } catch (error) {
        console.error('Error initializing YouTube to Shopify:', error);
      }
    }

    // Add this method to your AdjeiYouTubeToShopify class
    showLoading() {
      if (this.videoContainer) {
        this.videoContainer.innerHTML = `
      <div class="loading">
        <div class="loading-spinner"></div>
        <p>Loading videos...</p>
      </div>
    `;
      }
    }

    // Add these new background check methods
    async checkForChannelUpdatesInBackground(storedData) {
      try {
        const needsUpdate = await checkForChannelUpdates(this.channelId, storedData);
        if (needsUpdate) {
          console.log('Channel data update needed, fetching in background');
          await this.loadChannelInfo(true); // true = silent update
        }
      } catch (error) {
        console.error('Error checking for channel info updates:', error);
      }
    }

    // Add these new background check methods
    async checkForVideosUpdatesInBackground(storedData) {
      try {
        const needsUpdate = await checkForChannelUpdates(this.channelId, storedData);
        if (needsUpdate) {
          // console.log('Channel video update needed, fetching in background');
          await this.loadVideos(true); // true = silent update
        }
      } catch (error) {
        console.error('Error checking for channel video updates:', error);
      }
    }

    // Set up event listeners
    setupEventListeners() {
      // Pagination controls
      if (this.prevButton && this.nextButton) {
        this.prevButton.addEventListener('click', () => this.changePage('prev'));
        this.nextButton.addEventListener('click', () => this.changePage('next'));
      }

      // Modal controls
      if (this.closeModal) {
        this.closeModal.addEventListener('click', () => this.closeVideoModal());

        // Close modal when clicking outside content
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.closeVideoModal();
          }
        });

        // Close modal with Escape key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal.style.display === 'block') {
            this.closeVideoModal();
          }
        });
      }
    }

    async loadChannelInfo(silentUpdate = false) {
      try {
        // If no channel ID is provided, skip loading channel info
        if (!this.channelId) {
          console.warn('❌ No YouTube channel ID provided.');
          return;
        }

        console.log("🔗 Fetching channel data from:", `https://www.youtube.com/channel/${this.channelId}`);
        const channelUrl = `https://www.youtube.com/channel/${this.channelId}`;
        const htmlContent = await fetchWithFallbacks(channelUrl);

        if (!htmlContent) {
          throw new Error('❌ Failed to fetch channel data.');
        }

        // Extract ytInitialData
        let ytData;
        if (typeof htmlContent === 'string') {
          console.log("📄 Received raw HTML, extracting ytInitialData...");
          const initialDataMatch = htmlContent.match(/var ytInitialData = (.+?);<\/script>/s);
          if (!initialDataMatch) {
            throw new Error('❌ Could not find ytInitialData in the response.');
          }
          ytData = JSON.parse(initialDataMatch[1]);
        } else {
          console.log("📄 Received parsed JSON, using it directly...");
          ytData = htmlContent;
        }

        console.log("✅ Extracted ytInitialData from loadChannelInfo:", ytData);

        // Extract channel information
        let channelTitle = '';
        let subscriberCount = '';
        let channelDescription = '';
        let avatarUrl = '';
        let bannerUrl = '';

        try {
          channelTitle = ytData.header?.pageHeaderRenderer?.content?.pageHeaderViewModel?.title?.dynamicTextViewModel?.text?.content || 'Unknown Title';
        } catch (e) {
          console.warn('⚠️ Could not extract channel title:', e);
        }

        try {
          subscriberCount = ytData.header?.pageHeaderRenderer?.content?.pageHeaderViewModel?.metadata?.contentMetadataViewModel?.metadataRows?.[1]?.metadataParts?.[0]?.text?.content || '';
        } catch (e) {
          console.warn('⚠️ Could not extract subscriber count:', e);
        }

        try {
          channelDescription = ytData.header?.pageHeaderRenderer?.content?.pageHeaderViewModel?.description?.descriptionPreviewViewModel?.description?.content || '';
        } catch (e) {
          console.warn('⚠️ Could not extract channel description:', e);
        }

        try {
          avatarUrl = ytData.metadata?.channelMetadataRenderer?.avatar?.thumbnails?.[0]?.url || '';
        } catch (e) {
          console.warn('⚠️ Could not extract avatar URL:', e);
        }

        try {
          bannerUrl = ytData.header?.pageHeaderRenderer?.content?.pageHeaderViewModel?.banner?.imageBannerViewModel?.image?.sources?.[3]?.url || '';
        } catch (e) {
          console.warn('⚠️ Could not extract banner URL:', e);
        }

        // Find latest video ID
        let latestVideoId = '';
        try {
          const videosTab = ytData.contents?.twoColumnBrowseResultsRenderer?.tabs?.find(tab =>
            tab.tabRenderer?.title === 'Videos'
          );

          if (videosTab?.tabRenderer?.content?.richGridRenderer?.contents?.length > 0) {
            latestVideoId = videosTab.tabRenderer.content.richGridRenderer.contents[0]?.richItemRenderer?.content?.gridVideoRenderer?.videoId || '';
          }
        } catch (e) {
          console.warn('⚠️ Could not extract latest video ID:', e);
        }

        // Store channel info
        this.channelInfo = {
          title: channelTitle,
          subscriberCount: subscriberCount,
          description: channelDescription,
          avatarUrl: avatarUrl,
          bannerUrl: bannerUrl,
          latestVideoId: latestVideoId
        };

        // Save to storage
        saveChannelData(this.channelId, this.channelInfo);

        // Only update the UI if this is not a silent update
        if (!silentUpdate) {
          this.updateChannelInfo();
        }
      } catch (error) {
        console.error('❌ Error loading channel info:', error);

        // Fallback to minimal channel info
        this.channelInfo = {
          title: 'YouTube Channel',
          subscriberCount: '',
          description: '',
          avatarUrl: '',
          bannerUrl: ''
        };

        if (!silentUpdate) {
          this.updateChannelInfo();
        }
      }
    }

    // Update the UI with channel information
    updateChannelInfo() {
      // Only update if we have channel info elements
      if (!this.channelInfo) return;
      // Update channel title if no custom title is set
      if (this.channelTitle && !this.channelTitle.textContent.trim()) {
        this.channelTitle.textContent = this.channelInfo.title;
      }

      // Update avatar
      if (this.channelAvatar && this.channelInfo.avatarUrl) {
        this.channelAvatar.src = this.channelInfo.avatarUrl;
        this.channelAvatar.alt = this.channelInfo.title;
      }

      // Update banner
      if (this.channelBanner && this.channelInfo.bannerUrl) {
        this.channelBanner.src = this.channelInfo.bannerUrl;
        this.channelBanner.alt = `${this.channelInfo.title} banner`;
      }

      // Update subscriber count
      if (this.subscriberCount) {
        this.subscriberCount.textContent = this.channelInfo.subscriberCount;
      }

      // Update channel description
      if (this.channelDescription) {
        this.channelDescription.innerHTML = this.channelInfo.description;
      }

      // Create or update the Subscribe button
      let subscribeContainer = this.container.querySelector('.subscribe-container');
      subscribeContainer.addEventListener('click', () => this.subscribeToChannel());
      if (!subscribeContainer) {
        subscribeContainer = document.createElement('div');
        subscribeContainer.className = 'subscribe-container';

        const subscribeButton = document.createElement('button');
        subscribeButton.className = 'subscribe-btn';
        subscribeButton.textContent = 'Subscribe';
        subscribeButton.addEventListener('click', () => this.subscribeToChannel());

        subscribeContainer.appendChild(subscribeButton);
        this.container.appendChild(subscribeContainer); // Append the subscribe button under the channel info
      }
    }

    subscribeToChannel() {
      if (!this.channelId) {
        alert('Channel ID is missing.');
        return;
      }

      const subscribeUrl = `https://www.youtube.com/channel/${this.channelId}?sub_confirmation=1`;
      window.open(subscribeUrl, '_blank');
    }

    async loadVideos(silentUpdate = false) {
      try {
        if (!this.channelId) {
          console.warn('❌ No YouTube channel ID provided.');
          return;
        }

        // console.log("🔗 Fetching videos from:", `https://www.youtube.com/channel/${this.channelId}/videos`);
        const videosUrl = `https://www.youtube.com/channel/${this.channelId}/videos`;
        const htmlContent = await fetchWithFallbacks(videosUrl);

        if (!htmlContent) {
          throw new Error('❌ Failed to fetch videos data');
        }

        // Extract ytInitialData
        let ytData;
        if (typeof htmlContent === 'string') {
          console.log("📄 Received raw HTML, extracting ytInitialData...");
          const initialDataMatch = htmlContent.match(/var ytInitialData = (.+?);<\/script>/s);
          if (!initialDataMatch) {
            throw new Error('❌ Could not find ytInitialData in the response.');
          }
          ytData = JSON.parse(initialDataMatch[1]);
        } else {
          // console.log("📄 Received parsed JSON, using it directly...");
          ytData = htmlContent;
        }

        console.log("✅ Extracted ytInitialData from async loadVideos(silentUpdate = false):", ytData);

        let videoItems = [];

        try {
          const gridRenderer = ytData.contents?.twoColumnBrowseResultsRenderer?.tabs
            ?.find(tab => tab.tabRenderer?.title === 'Videos')
            ?.tabRenderer?.content?.richGridRenderer;

          if (gridRenderer?.contents) {
            console.log("📂 gridRenderer.contents:", gridRenderer.contents);

            videoItems = gridRenderer.contents
              .map(item => item.richItemRenderer?.content?.videoRenderer) // Extract videos
              .filter(video => video && video.videoId) // Ensure it has a valid videoId
              .map(video => ({
                id: video.videoId,
                title: video.title?.runs?.[0]?.text || 'Untitled Video',
                thumbnail: video.thumbnail?.thumbnails?.[0]?.url || '',
                publishedTime: video.publishedTimeText?.simpleText || '',
                viewCount: video.viewCountText?.simpleText || '',
                duration: video.thumbnailOverlays?.[0]?.thumbnailOverlayTimeStatusRenderer?.text?.simpleText || '',
                url: `https://www.youtube.com/watch?v=${video.videoId}`
              }));

            console.log("📺 Extracted Video Items After Fix:", videoItems);

          }
        } catch (e) {
          console.error('❌ Error extracting videos:', e);
        }

        console.log("📺 Extracted Video Items:", videoItems);

        // If no videos are found, show an error in the UI
        if (videoItems.length === 0) {
          console.warn("⚠️ No videos found! The structure of `ytInitialData` might have changed.");
          this.videoContainer.innerHTML = `<p class="error-message">No videos found. Please check YouTube's data structure.</p>`;
        }

        this.videos = videoItems;
        saveVideosData(this.channelId, videoItems);

        if (!silentUpdate) {
          this.renderVideos();
          this.updatePagination();
        }
      } catch (error) {
        console.error('❌ Error loading videos:', error);
      }
    }

    // Update renderVideos to handle different content types
    renderVideos() {
      // Clear the container
      if (!this.videoContainer) return;
      this.videoContainer.innerHTML = '';

      // Calculate pagination
      const startIndex = (this.currentPage - 1) * this.videosPerPage;
      const endIndex = startIndex + this.videosPerPage;
      const currentPageVideos = this.videos.slice(startIndex, endIndex);

      // If no videos, show message
      if (currentPageVideos.length === 0) {
        let tabName = this.currentTab || "videos"; // Use "videos" as default if undefined
        this.videoContainer.innerHTML = `
            <div class="no-videos-message">
                <p>No ${tabName} found for this channel.</p>
            </div>
            `;
        return;
      }

      // Create video elements
      currentPageVideos.forEach(video => {
        // Create video element
        const videoElement = document.createElement('div');
        videoElement.className = 'video-item';
        videoElement.setAttribute('data-video-id', video.id);

        // Format duration if available
        let formattedDuration = '';
        if (video.duration) {
          formattedDuration = `<span class="video-duration">${video.duration}</span>`;
        }

        // Create HTML for video item based on layout
        if (this.layout === 'grid') {
          videoElement.innerHTML = `
        <div class="video-thumbnail">
          <img class="thumbnail-img" src="${video.thumbnail}" alt="${video.title}" loading="lazy">
          ${formattedDuration}
          <span class="play-icon"></span>
        </div>
        <div class="video-info">
          <h3 class="video-title">${video.title}</h3>
          <div class="video-meta">
            ${video.viewCount ? `<span class="video-views">${video.viewCount}</span>` : ''}
            ${video.publishedTime ? `<span class="video-published">${video.publishedTime}</span>` : ''}
          </div>
        </div>
      `;
        } else {
          // List layout
          videoElement.innerHTML = `
        <div class="video-thumbnail">
          <img class="thumbnail-img" src="${video.thumbnail}" alt="${video.title}" loading="lazy">
          ${formattedDuration}
          <span class="play-icon"></span>
        </div>
        <div class="video-info">
          <h3 class="video-title">${video.title}</h3>
          <div class="video-meta">
            ${video.viewCount ? `<span class="video-views">${video.viewCount}</span>` : ''}
            ${video.publishedTime ? `<span class="video-published">${video.publishedTime}</span>` : ''}
          </div>
        </div>
      `;
        }

        // Add click event to open video
        videoElement.addEventListener('click', () => {
          if (video.isPlaylist) {
            // Open playlist in a new tab
            window.open(video.url, '_blank');
          } else {
            // Open video in modal
            this.openVideoModal(video.id, video.isLive);
          }
        });

        // Add to container
        this.videoContainer.appendChild(videoElement);
      });
    }

    // Update openVideoModal to handle different content types
    openVideoModal(videoId, isLive = false) {
      if (!this.modal || !this.videoPlayer) return;

      // Create iframe for YouTube video
      let embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

      // Add parameters based on settings and content type
      if (this.disableSuggestions) {
        embedUrl += '&rel=0';
      }

      if (this.onlyChannelSuggestions) {
        embedUrl += '&rel=1';
      }

      // For shorts, use the shorts player
      if (this.currentTab === 'shorts') {
        embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&loop=1&playlist=${videoId}`;
      }

      // For live streams, add live chat if available
      if (isLive) {
        embedUrl += '&autoplay=1';
      }

      this.videoPlayer.innerHTML = `
    <iframe 
      width="100%" 
      height="100%" 
      src="${embedUrl}" 
      title="YouTube video player" 
      frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
      allowfullscreen>
    </iframe>
  `;

      // Show modal
      this.modal.style.display = 'block';
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    }


    // Close video modal
    closeVideoModal() {
      if (!this.modal || !this.videoPlayer) return;

      // Hide modal
      this.modal.style.display = 'none';
      document.body.style.overflow = ''; // Restore scrolling

      // Stop video by clearing the player
      this.videoPlayer.innerHTML = '';
    }

    updatePagination() {
      if (!this.paginationControls) return;

      this.paginationControls.innerHTML = '';
      const totalPages = Math.ceil(this.videos.length / this.videosPerPage);
      const maxVisiblePages = 5;

      const prevButton = document.createElement('button');
      prevButton.textContent = '« Prev';
      prevButton.className = 'prev-page';
      prevButton.disabled = this.currentPage === 1;
      prevButton.addEventListener('click', () => this.changePage('prev'));
      this.paginationControls.appendChild(prevButton);

      let startPage, endPage;
      if (totalPages <= maxVisiblePages) {
        startPage = 1;
        endPage = totalPages;
      } else if (this.currentPage <= 3) {
        startPage = 1;
        endPage = maxVisiblePages;
      } else if (this.currentPage >= totalPages - 2) {
        startPage = totalPages - (maxVisiblePages - 1);
        endPage = totalPages;
      } else {
        startPage = this.currentPage - 2;
        endPage = this.currentPage + 2;
      }

      if (startPage > 1) {
        this.addPageButton(1);
        if (startPage > 2) this.addEllipsis();
      }

      for (let i = startPage; i <= endPage; i++) {
        this.addPageButton(i);
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) this.addEllipsis();
        this.addPageButton(totalPages);
      }

      const nextButton = document.createElement('button');
      nextButton.textContent = 'Next »';
      nextButton.className = 'next-page';
      nextButton.disabled = this.currentPage === totalPages;
      nextButton.addEventListener('click', () => this.changePage('next'));
      this.paginationControls.appendChild(nextButton);
    }


    // Helper function to add a page number button
    addPageButton(pageNumber) {
      const pageButton = document.createElement('button');
      pageButton.textContent = pageNumber;
      pageButton.className = 'page-number';
      if (pageNumber === this.currentPage) {
        pageButton.classList.add('current'); // Active page styling
      }
      pageButton.addEventListener('click', () => {
        this.currentPage = pageNumber;
        this.renderVideos();
        this.updatePagination();
        this.videoContainer.scrollTop = 0; // Scroll only inside the container
      });
      this.paginationControls.appendChild(pageButton);
    }


    // Helper function to add an ellipsis ("...") indicator
    addEllipsis() {
      const ellipsis = document.createElement('span');
      ellipsis.textContent = '...';
      ellipsis.className = 'pagination-ellipsis';
      this.paginationControls.appendChild(ellipsis);
    }

    // Change page
    changePage(direction) {
      // Calculate total pages
      const totalPages = Math.ceil(this.videos.length / this.videosPerPage);

      // Update current page based on direction
      if (direction === 'prev' && this.currentPage > 1) {
        this.currentPage--;
      } else if (direction === 'next' && this.currentPage < totalPages) {
        this.currentPage++;
      } else {
        return; // No change needed
      }

      // Re-render videos with new page
      this.renderVideos();

      // Update pagination controls
      this.updatePagination();

      // Scroll to top of video container
      this.videoContainer.scrollTop = 0;

    }

  }//end of class

  // Initialize all YouTube to Shopify sections on the page
  const youtubeContainers = document.querySelectorAll('#adjeii-youtube-to-shopify');

  youtubeContainers.forEach(container => {
    new AdjeiYouTubeToShopify(container);
  });

  // Add a function to clear cache if needed (for debugging or manual refresh)
  window.clearYouTubeCache = function (channelId = null) {
    if (channelId) {
      // Clear specific channel
      localStorage.removeItem(`${STORAGE_KEYS.CHANNEL_DATA}${channelId}`);
      localStorage.removeItem(`${STORAGE_KEYS.VIDEOS_DATA}${channelId}`);
      console.log(`Cleared cache for channel ${channelId}`);
    } else {
      // Clear all YouTube data
      clearAllYouTubeData();
      console.log('Cleared all YouTube cache');
    }

    // Reload the page to fetch fresh data
    window.location.reload();
  };

  // Add loading state styles if not already in your CSS
  function addLoadingStyles() {
    if (!document.getElementById('adjeii-youtube-loading-styles')) {
      const style = document.createElement('style');
      style.id = 'adjeii-youtube-loading-styles';
      style.textContent = `
      .adjeii-youtube-section .loading {
        text-align: center;
        padding: 2rem;
      }
      
      .adjeii-youtube-section .loading-spinner {
        display: inline-block;
        width: 40px;
        height: 40px;
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        border-top-color: #333;
        animation: spin 1s ease-in-out infinite;
      }
      
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      
      .adjeii-youtube-section .error-message {
        text-align: center;
        padding: 2rem;
        color: #d32f2f;
      }
    `;
      document.head.appendChild(style);
    }
  }

  function getContinuationToken(htmlContent) {
    const match = htmlContent.match(/"continuationCommand":{"token":"(.*?)"/);
    return match ? match[1] : null;
  }


});
